export default "__VITE_ASSET__B6K3V$bp__"